import styled, { css } from 'styled-components'

interface MenuContentProps {
  isOpen: boolean
}

export const MenuContent = styled.div<MenuContentProps>`
  padding-bottom: ${({ theme }) => theme.rem(24)};
  min-height: 100svh;
  width: 100%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transition: transform 0.4s ease-out;
  background-color: #fff;

  ${({ theme }) =>
    theme.mediaQuery.lg(`
    padding-top: ${theme.rem(24)};
  `)}

  ${({ theme, isOpen }) =>
    theme.mediaQuery.xl(`
    min-height: ${theme.rem(380)};
    padding-top: 0;
    transform: translateY(${isOpen ? '0' : '-100%'});   
  `)}
`

export const MenuContentGoBack = styled.div`
  margin-bottom: ${({ theme }) => theme.rem(8)};

  > button {
    padding-left: 0;
  }
`

export const MenuContentInner = styled.div`
  background-color: #fff;
  padding-bottom: ${({ theme }) => theme.rem(24)};

  ${({ theme }) =>
    theme.mediaQuery.xl(`
    padding: ${theme.rem(24)};
  `)}
`
export const MenuCloseButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`
